export function gcd(a: number, b: number): number {
  let x = Math.abs(a);
  let y = Math.abs(b);
  while (y) {
    const t = y;
    y = x % y;
    x = t;
  }
  return x || 1;
}

export function formatParts(value: number, maxValue: number): string {
  if (maxValue <= 0) return String(value);
  const sign = value < 0 ? '-' : '';
  const abs = Math.abs(value);
  const g = gcd(abs, maxValue);
  const n = abs / g;
  const d = maxValue / g;
  if (d === 1) return `${sign}${n}`;
  return `${sign}${n}/${d}`;
}

export function defaultFractionSteps(maxValue: number): Array<{ id: string; parts: number; label: string }> {
  const quarter = Math.max(1, Math.round(maxValue / 4));
  const half = Math.max(1, Math.round(maxValue / 2));
  return [
    { id: 'p_unit', parts: 1, label: formatParts(1, maxValue) },
    { id: 'p_half', parts: half, label: `+${formatParts(half, maxValue)}` },
    { id: 'm_unit', parts: -1, label: `−${formatParts(1, maxValue)}` },
    { id: 'm_quarter', parts: -quarter, label: `−${formatParts(quarter, maxValue)}` },
  ];
}
